// GraphQL liefert für nicht sichtbare oder fehlende Einträge null: Listen immer hiermit bereinigen
export const compact = <T>(items?: (T | null | undefined)[] | null): T[] =>
  (items || []).filter((item): item is T => item !== null && item !== undefined)
